import { ref } from "vue";
var OverlayMap = /* @__PURE__ */ ((OverlayMap2) => {
  OverlayMap2["AISubtitlesOverlay"] = "AISubtitlesOverlay";
  OverlayMap2["RoomInviteOverlay"] = "RoomInviteOverlay";
  return OverlayMap2;
})(OverlayMap || {});
const overlayMap = ref({
  [
    "AISubtitlesOverlay"
    /* AISubtitlesOverlay */
  ]: { visible: false },
  [
    "RoomInviteOverlay"
    /* RoomInviteOverlay */
  ]: { visible: false }
});
function useRoomOverlayHooks() {
  const getOverlayMap = () => overlayMap;
  const toggleOverlayVisibility = (overlay, isShow) => {
    overlayMap.value[overlay].visible = isShow;
  };
  return {
    getOverlayMap,
    toggleOverlayVisibility
  };
}
export {
  OverlayMap,
  useRoomOverlayHooks
};
